// las relaciones permitidas de una definición son los vínculos del tributo que tiene asignada
export const TIPOS_VINCULO_CUENTA = {
    10: 'TipoVinculoInmueble',
    11: 'TipoVinculoComercio',
    12: 'TipoVinculoVehiculo',
    13: 'TipoVinculoCementerio',
    14: 'TipoVinculoFondeadero',
    15: 'TipoVinculoEspecial',
}

export const initialFormValues = {
    id: -1,
    idEstadoPagoContadoDefinicion: 0,
    idTipoPlanPago: 0,
    idTipoTributo: 0,
    idTipoVencimiento: 0,
    idTasaPagoContado: 0,
    idSubTasaPagoContado: 0,
    codigo: '',
    descripcion: '',
    fechaDesde: null,
    fechaHasta: null,
    idTipoAlcanceTemporal: 0,
    fechaDesdeAlcanceTemporal: null,
    fechaHastaAlcanceTemporal: null,
    mesDesdeAlcanceTemporal: 0,
    mesHastaAlcanceTemporal: 0,
    aplicaDerechosEspontaneos: false,
    aplicaTotalidadDeudaAdministrativa: false,
    aplicaDeudaAdministrativa: false,
    aplicaDeudaLegal: false,
    incluyeDeudaNoVencida: false,
    cobraSellados: false,
    aplicaGranContribuyente: false,
    aplicaPequenioContribuyente: false,
    noAplicaDeudoresDDJJ: false,
    montoDeudaAdministrativaDesde: 0,
    montoDeudaAdministrativaHasta: 0,
    idViaConsolidacion: 0,
    porcentajeQuitaRecargos: 0,
    porcentajeQuitaMultaInfracciones: 0,
    porcentajeQuitaHonorarios: 0,
    porcentajeQuitaAportes: 0,
    idUsuarioCreacion: 0,
    fechaCreacion: null
}

export const initialOtherValues = {
    archivos: [],
    observaciones: [],
    etiquetas: [],
    pagosContadoDefinicionAlcanceTasa: [],
    pagosContadoDefinicionAlcanceRubro: [],
    pagosContadoDefinicionAlcanceGrupo: [],
    pagosContadoDefinicionAlcanceZonaTarifaria: [],
    pagosContadoDefinicionAlcanceTipoCondicionEspecial: [],
    pagosContadoDefinicionAlcanceCondicionFiscal: [],
    pagosContadoDefinicionAlcanceRubroAfip: [],
    pagosContadoDefinicionAlcanceFormaJuridica: [],
    pagosContadoDefinicionTipoVinculoCuenta: [],
}

export const formatDataForPut = (data, otherValues) => {
    const newOtherValues = {}
    Object.keys(otherValues).forEach(key => {
        if (key === 'pagoContadoDefinicion') return
        if (key === 'pagosContadoDefinicionTipoVinculoCuenta') {
            newOtherValues[key] = otherValues[key].filter(item => !(item.state === 'r' && item.id < 0))
        } else {
            newOtherValues[key] = otherValues[key].filter(item => item.state !== 'o' && !(item.state === 'r' && item.id < 0))
        }
    })

    return {
        ...newOtherValues,
        pagoContadoDefinicion: data,
    }
}

// cada icono se dibuja solo si le pasaron su callback: una grilla que no tiene nada
// que ver ni que editar (el alcance por tasas) pide solo onAdd y onRemove
export const buildCellAVMR = ({ onAdd, onView, onModify, onRemove, readOnly }) => ({
    id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true,
    Header: (props) => readOnly ? <div/> : (
        <div className='action'>
            <div onClick={onAdd} className="link">
                <span className="material-symbols-outlined" title="Nuevo">add</span>
            </div>
        </div>
    ),
    Cell: (props) =>  (
        <div className='action'>
            {onView && <div onClick={() => onView(props.row.original)} className="link">
                <span className="material-symbols-outlined" title="Ver">search</span>
            </div>}
            {!readOnly && <>
                {onModify && <div onClick={() => onModify(props.row.original)} className="link">
                <span className="material-symbols-outlined" title="Modificar">stylus</span>
                </div>}
                {onRemove && <div onClick={() => onRemove(props.row.original)} className="link">
                <span className="material-symbols-outlined" title="Eliminar">delete</span>
                </div>}
            </>}
        </div>
    ),
})